import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, type InquiryCategory } from '../../lib/api.js';

export function NewInquiry() {
  const navigate = useNavigate();
  const [category, setCategory] = useState<InquiryCategory>('product');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const res = await api.post<{ inquiry: { id: string } }>('/api/customer/inquiries', {
        category,
        subject,
        body,
      });
      navigate(`/customer/inquiries/${res.inquiry.id}`, { replace: true });
    } catch (err) {
      setError((err as Error).message);
      setLoading(false);
    }
  }

  return (
    <div>
      <header className="mb-6">
        <h1 className="text-2xl font-semibold tracking-tight">새 문의 작성</h1>
      </header>

      <form
        onSubmit={submit}
        className="max-w-2xl bg-surface border border-neutral-200 rounded-lg p-6 space-y-4"
      >
        <label className="block">
          <span className="block text-sm font-medium text-neutral-800 mb-1">카테고리</span>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value as InquiryCategory)}
            className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-brand-400"
          >
            <option value="product">제품 문의</option>
            <option value="license">라이선스 문의</option>
          </select>
        </label>

        <label className="block">
          <span className="block text-sm font-medium text-neutral-800 mb-1">제목</span>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
            maxLength={200}
            className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </label>

        <label className="block">
          <span className="block text-sm font-medium text-neutral-800 mb-1">내용</span>
          <textarea
            value={body}
            onChange={(e) => setBody(e.target.value)}
            required
            rows={8}
            maxLength={10000}
            className="w-full px-3 py-2 border border-neutral-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-brand-400"
          />
        </label>

        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded-md text-sm text-red-700">
            {error}
          </div>
        )}

        <div className="pt-2 flex gap-2">
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-brand-400 hover:bg-brand-600 disabled:bg-neutral-300 text-white text-sm font-medium rounded-md"
          >
            {loading ? '전송 중…' : '문의 등록'}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="px-4 py-2 border border-neutral-300 text-neutral-700 text-sm font-medium rounded-md hover:bg-neutral-50"
          >
            취소
          </button>
        </div>
      </form>
    </div>
  );
}
